import angular from 'angular';
import AsideMenuComponent from './aside-menu.component';

export default angular
  .module('verifyApp.aside-menu', [])
  .component('asideMenu', AsideMenuComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/aside-menu/index.js